/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { addDependencies } from './dependenciesAdd.generated.js';
import { ctransposeDependencies } from './dependenciesCtranspose.generated.js';
import { deepEqualDependencies } from './dependenciesDeepEqual.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { dotDependencies } from './dependenciesDot.generated.js';
import { dotDivideDependencies } from './dependenciesDotDivide.generated.js';
import { equalDependencies } from './dependenciesEqual.generated.js';
import { invDependencies } from './dependenciesInv.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { multiplyDependencies } from './dependenciesMultiply.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createPinv } from '../../factoriesAny.js';
export var pinvDependencies = {
  ComplexDependencies,
  addDependencies,
  ctransposeDependencies,
  deepEqualDependencies,
  divideScalarDependencies,
  dotDependencies,
  dotDivideDependencies,
  equalDependencies,
  invDependencies,
  matrixDependencies,
  multiplyDependencies,
  typedDependencies,
  createPinv
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesPinv.generated.js
// module id = 1434
// module chunks = 2